import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
        <Link to="/" className="text-orange-500 hover:text-orange-600 mb-8 inline-block">
          ← Back to Home
        </Link>
        
        <h1 className="text-4xl font-bold mb-4">Terms of Service</h1>
        <p className="text-gray-400 mb-8">Last Updated: {new Date().toLocaleDateString()}</p>
        
        <div className="space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing and using Trap Comix ("the Platform"), you agree to be bound by these Terms of Service. 
              If you do not agree to these terms, please do not use the Platform.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. User Accounts</h2>
            <ul className="list-disc list-inside space-y-2">
              <li>You must be at least 13 years old to create an account</li>
              <li>You are responsible for maintaining the security of your account</li>
              <li>You must provide accurate and complete information</li>
              <li>You may not impersonate others or create false identities</li>
              <li>One person may not maintain multiple accounts</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. Intellectual Property & Creator Rights</h2>
            <p className="mb-3">
              <strong className="text-orange-500">You Own Your Content.</strong> Creators retain full ownership of all intellectual 
              property rights to content they upload, including comics, artwork, music, and written works.
            </p>
            <ul className="list-disc list-inside space-y-2">
              <li>By uploading content, you grant Trap Comix a non-exclusive license to display and distribute your work on the Platform</li>
              <li>You represent that you own or have the rights to all content you upload</li>
              <li>You may not upload content that infringes on others' copyrights or trademarks</li>
              <li>Trap Comix respects DMCA takedown requests (see DMCA Policy)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Content Guidelines</h2>
            <p className="mb-3">Prohibited content includes but is not limited to:</p>
            <ul className="list-disc list-inside space-y-2">
              <li>Illegal content or content that promotes illegal activities</li>
              <li>Hate speech, harassment, or discrimination</li>
              <li>Sexual content involving minors</li>
              <li>Spam, scams, or deceptive practices</li>
              <li>Malware, viruses, or malicious code</li>
              <li>Content that violates others' privacy or rights</li>
            </ul>
            <p className="mt-3 text-yellow-500">
              Mature content (violence, sexual themes, profanity) must be properly tagged and age-gated.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">5. Monetization & Payments</h2>
            <ul className="list-disc list-inside space-y-2">
              <li>Creators may monetize content through tips, subscriptions, and premium content</li>
              <li>Trap Comix takes a platform fee (details provided separately)</li>
              <li>Payments are processed through Stripe</li>
              <li>Creators must comply with tax laws in their jurisdiction</li>
              <li>Refunds are handled on a case-by-case basis</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">6. Community Conduct</h2>
            <p className="mb-3">Users must:</p>
            <ul className="list-disc list-inside space-y-2">
              <li>Treat others with respect</li>
              <li>Not engage in harassment, bullying, or threats</li>
              <li>Not manipulate engagement metrics (fake likes, views, etc.)</li>
              <li>Not spam or post unsolicited advertising</li>
              <li>Report violations to moderators</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">7. Termination</h2>
            <p>
              Trap Comix reserves the right to suspend or terminate accounts that violate these Terms of Service. 
              Serious violations may result in immediate and permanent bans without warning.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">8. Disclaimers</h2>
            <ul className="list-disc list-inside space-y-2">
              <li>The Platform is provided "as is" without warranties of any kind</li>
              <li>Trap Comix is not responsible for user-generated content</li>
              <li>We are not liable for financial losses resulting from platform use</li>
              <li>We reserve the right to modify or discontinue services at any time</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">9. Changes to Terms</h2>
            <p>
              We may update these Terms of Service periodically. Continued use of the Platform after changes 
              constitutes acceptance of the new terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">10. Contact</h2>
            <p>
              For questions about these Terms, contact us at: <br />
              <a href="mailto:legal@trapcomix.com" className="text-orange-500 hover:text-orange-600">
                legal@trapcomix.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;